import TeamworkupTV from '@/views/intranet/teamworkup-tv/TeamworkupTV.vue'
import TeamworkupTVSingle from '@/views/intranet/teamworkup-tv-single/TeamworkupTVSingle.vue'

export const teamworkupTV = {
  path: '/videos',
  name: 'Videos',
  component: TeamworkupTV,
  meta: { requiresAuth: true }
}

export const teamworkupTVSingle = {
  path: '/videos/:id',
  name: 'VideosSingle',
  component: TeamworkupTVSingle,
  meta: { requiresAuth: true }
}
